export enum SocialMediaUserStatusEnum {
  noRegistered = 0,
  registered = 1
}
